import { SessionStorage } from '../storage/session/SessionStorage';

class URLController {
  sessionData?: Record<string, string>;

  getParamValue = (name: string, urlSearchParams: URLSearchParams): string | null => {
    if (urlSearchParams.get(name) === null) {
      if (this.sessionData) {
        return this.sessionData[name];
      } else {
        const PPG = SessionStorage.getJson('PPG');
        if (PPG) {
          this.sessionData = PPG;
          if (this.sessionData) {
            return this.sessionData[name];
          }
        }
        return null;
      }
    } else {
      return urlSearchParams.get(name);
    }
  };
}

const URLControllerInstance = new URLController();

export default URLControllerInstance;

export class URLUtilities {
  /**
   * A method to combine a base URL with a path.
   * It handles slashes between the base and the path.
   * If base is empty, it will throw an error as it is not a valid URL.
   * */
  public static combine(basePath: string, path: string): URL {
    const baseURL = new URL(basePath);
    return new URL(path, baseURL);
  }
}
